module.exports = __webpack_public_path__ + "static/media/Portrait-10036.9363cd68.jpg";